import { SignIn } from "@clerk/clerk-react";
import { View } from "react-native";

/**
 * Login Page with Clerk Authentication
 *
 * Uses Clerk's pre-built SignIn component which provides:
 * - Social login (Google, GitHub)
 * - Email/password authentication
 * - Invitation-only enforcement (configured in Clerk dashboard)
 * - Secure session management
 * - Automatic redirects after successful sign-in
 *
 * IMPORTANT: Invitation-only mode must be enabled in Clerk dashboard:
 * Dashboard → Configure → Restrictions → Enable "Restrict sign-ups"
 */
export default function LoginPage() {
	return (
		<View
			style={{
				flex: 1,
				justifyContent: "center",
				alignItems: "center",
				padding: 20,
			}}
		>
			<SignIn
				routing="path"
				path="/login"
				redirectUrl="/patients" // Redirect to patients page after login
			/>
		</View>
	);
}
